(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-dawn-lookbook"] && !Shopify.designMode) return;
  try {
     
  class KsLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.ks-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.ks-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('ks-lookbook', KsLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-whatsapp-chat"] && !Shopify.designMode) return;
  try {
     
  class SalehWhatsAppChat extends HTMLElement {
    constructor () {
      super ()

      this.chatButton = this.querySelector('#saleh-whatsapp-chat-btn')
      this.dialog = this.querySelector('#saleh-whatsapp-chat-dialog')
      this.userForm = this.querySelector('#saleh-whatsapp-chat-dialog-user-form')
      this.userInput = this.querySelector('#saleh-whatsapp-chat-dialog-user-input')
      this.whatsappNumber = this.dataset.whatsappNumber.split('-').join('')
      this.initialViewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight
      
      this.handleChatButtonClick()
      this.handelCloseDialogButtonClick()
      this.handleKeyboardVisibility()
      this.handleFormSubmit()
    }

    handleChatButtonClick () {
      this.chatButton.addEventListener('click', () => {
        if (this.dataset.hasDialog === 'true') {
          this.openDialog()
        } else {
          this.chatButton.classList.add('loading')
          setTimeout(() => {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
            this.chatButton.classList.remove('loading')
          }, 1000)
        }
      })
    }

    openDialog () {
      if (this.dialog.hasAttribute('open')) {
        this.closeDialog()
        return
      }

      this.dialog.style.transform = 'translateY(100px)';
      requestAnimationFrame(() => {
        this.dialog.style.transition = 'all .3s ease-out';
        this.dialog.style.transform = 'translateY(0)';
      });

      this.dialog.setAttribute('open', '')
      this.setAttribute('data-dialog-open', 'true')

      setTimeout(() => {
        this.userInput.focus()
      }, 300)
    
      setTimeout(() => {
        this.querySelector('#saleh-whatsapp-chat-dialog-msg-typing').style.display = 'none'
        this.querySelector('#saleh-whatsapp-chat-dialog-msg-text').style.display = 'block'
      }, 2000)

      this.trapFocus()
    }

    closeDialog () {
      this.dialog.removeAttribute('open')
      this.dialog.removeAttribute('data-keyboard-open')
      this.setAttribute('data-dialog-open', 'false')
      this.chatButton.focus()
    }
    
    handelCloseDialogButtonClick () {
      this.querySelector('#saleh-whatsapp-chat-dialog-close').addEventListener('click', () => {
        this.closeDialog()
      })
    }

    handleKeyboardVisibility () {
      // حل متقدم للكيبورد على الموبايل
      let isKeyboardOpen = false
      let keyboardHeight = 0

      // متابعة فتح/غلق الكيبورد
      this.userInput.addEventListener('focus', () => {
        isKeyboardOpen = true
        
        setTimeout(() => {
          this.dialog.setAttribute('data-keyboard-open', '')
          
          // على الموبايل - تأكد إن الـ input ظاهر
          if (window.innerWidth <= 749) {
            // حساب موقع الـ input
            const inputRect = this.userInput.getBoundingClientRect()
            const dialogRect = this.dialog.getBoundingClientRect()
            
            // لو الـ input تحت الكيبورد، اعمل scroll
            if (window.visualViewport) {
              const viewportBottom = window.visualViewport.height
              if (inputRect.bottom > viewportBottom - 20) {
                this.userInput.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'center',
                  inline: 'nearest' 
                })
              }
            }
          }
        }, 100)
      })

      this.userInput.addEventListener('blur', () => {
        isKeyboardOpen = false
        setTimeout(() => {
          if (!this.userInput.matches(':focus')) {
            this.dialog.removeAttribute('data-keyboard-open')
          }
        }, 100)
      })

      // Visual Viewport API - أفضل طريقة لـ iOS وAndroid الحديث
      if (window.visualViewport) {
        const handleViewportResize = () => {
          if (this.dialog.hasAttribute('open') && isKeyboardOpen) {
            const currentHeight = window.visualViewport.height
            const heightDiff = this.initialViewportHeight - currentHeight
            keyboardHeight = heightDiff
            
            if (heightDiff > 150) {
              this.dialog.setAttribute('data-keyboard-open', '')
              
              // تحديث موقع الـ Dialog ديناميكيًا
              requestAnimationFrame(() => {
                const inputRect = this.userInput.getBoundingClientRect()
                const viewportBottom = window.visualViewport.height
                
                // لو الـ input مش ظاهر، حركه لفوق
                if (inputRect.bottom > viewportBottom - 20) {
                  window.scrollBy({
                    top: inputRect.bottom - viewportBottom + 100,
                    behavior: 'smooth'
                  })
                }
              })
            } else {
              this.dialog.removeAttribute('data-keyboard-open')
            }
          }
        }

        window.visualViewport.addEventListener('resize', handleViewportResize)
        window.visualViewport.addEventListener('scroll', handleViewportResize)
      }

      // Fallback للـ Android القديم
      let lastHeight = window.innerHeight
      const handleWindowResize = () => {
        if (this.dialog.hasAttribute('open')) {
          const currentHeight = window.innerHeight
          const heightDiff = lastHeight - currentHeight
          
          if (heightDiff > 150 && isKeyboardOpen) {
            this.dialog.setAttribute('data-keyboard-open', '')
            
            setTimeout(() => {
              this.userInput.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'center' 
              })
            }, 100)
          } else if (heightDiff < -150) {
            this.dialog.removeAttribute('data-keyboard-open')
          }
          
          lastHeight = currentHeight
        }
      }

      window.addEventListener('resize', handleWindowResize)
    }

    trapFocus() {
      const focusableElements = this.dialog.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      )
      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      function handleTab(event) {
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault()
            lastElement.focus()
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault()
            firstElement.focus()
          }
        }
      }

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDialog())

      this.dialog.addEventListener('keydown', handleTab)

      return () => {
        this.dialog.removeEventListener('keydown', handleTab)
      }
    }

    handleFormSubmit () {
      this.userForm.addEventListener('submit', (event) => {
        event.preventDefault()
        this.querySelector('#saleh-whatsapp-chat-dialog-btn').classList.add('loading')

        setTimeout(() => {
          if (this.userInput.value) {
            const text = encodeURIComponent(this.userInput.value)
            window.open(`https://wa.me/${this.whatsappNumber}?text=${text}`, '_blank')
          } else {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
          }

          this.querySelector('#saleh-whatsapp-chat-dialog-btn').classList.remove('loading')
        }, 1000)
      })
    }
  }
  customElements.define('saleh-whatsapp-chat', SalehWhatsAppChat)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class KsStickyAtc extends HTMLElement {
    constructor () {
      super()

      this.variantSelector = this.querySelector('select[name="id"]')
      this.mainVariantInput = document.querySelector('.product .product-form input[name="id"]')
      this.hideAtFooter = this.dataset.hideAtFooter === 'true'

      this.handleVisibility()
      this.handleVariantChange()
      this.handleMainVariantChange()
    }

    handleVisibility () {
      const productForm = document.querySelector('product-info product-form')
      const footer = document.querySelector('footer, .footer, #shopify-section-footer')
      
      if (!productForm) return

      // الزر يظهر قبل نهاية الفورم بـ 300px
      const top = productForm.getBoundingClientRect().bottom + window.scrollY - 300

      window.addEventListener('scroll', () => {
        const scrollY = window.scrollY
        let shouldShow = scrollY > top

        // إخفاء الزر عند الوصول للفوتر (موبايل فقط)
        if (this.hideAtFooter && footer && shouldShow && window.innerWidth <= 749) {
          const footerTop = footer.getBoundingClientRect().top + scrollY
          const windowBottom = scrollY + window.innerHeight
          
          if (windowBottom >= footerTop) {
            shouldShow = false
          }
        }

        if (shouldShow) {
          this.classList.add('show')
          document.body.style.paddingBottom = this.clientHeight + 'px'
        } else {
          this.classList.remove('show')
          document.body.style.paddingBottom = 0
        }
      })
    }

    handleVariantChange () {
      if (!this.variantSelector) return

      this.variantSelector.addEventListener('change', () => {
        const selectedOption = this.variantSelector.querySelector('option:checked')
        const variantImg = selectedOption.getAttribute('data-img')
        const variantComparePrice = selectedOption.getAttribute('data-compare-price')
        const variantPrice = selectedOption.getAttribute('data-price')

        this.querySelectorAll('img').forEach(elem => {
          elem.src = variantImg
        })
 
        this.querySelectorAll('.price').forEach(elem => {
          if (variantComparePrice.length) {
            elem.classList.add('price--on-sale')
            elem.querySelector('.price__sale .price-item--regular').textContent = variantComparePrice
            elem.querySelector('.price__sale .price-item--sale').textContent = variantPrice
          } else {
            elem.classList.remove('price--on-sale')
            elem.querySelector('.price__regular .price-item--regular').textContent = variantPrice
          }
        })

        this.querySelectorAll('button[name="add"]').forEach(btn => {
          if (selectedOption.disabled) {
            btn.disabled = true
            btn.querySelector('span').textContent = this.dataset.textSoldOut
          } else {
            btn.disabled = false
            btn.querySelector('.sold-out-message').classList.add('hidden')
            btn.querySelector('span').textContent = this.dataset.textAddToCart
          }
        })
      })
    }

    handleMainVariantChange () {
      this.mainVariantInput.addEventListener('change', (event) => {
        this.variantSelector.value = this.mainVariantInput.value
        this.variantSelector.dispatchEvent(new Event('change'))
      })
    }
  }
  customElements.define('ks-sticky-atc', KsStickyAtc)

  } catch(e) { console.error(e); }
})();
})();
